import { Model } from 'app/model/backendmodel';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { Named, Owned } from 'app/model/base/named';
import { FileLocationAdapter } from './file-location.adapter';
import { FtpServerLocation } from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(FtpServerLocation)
})
export class FtpServerLocationLocationAdapter extends FileLocationAdapter<FtpServerLocation, Model.DatasetLocation> {
    public _toResource(store: FtpServerLocation): Model.FtpServerLocation {
        const resource: Model.FtpServerLocation = {
            type: 'FtpServerLocation',
            fileName: ValueAdapter.toResource(store, FtpServerLocation.FILE_NAME) || undefined,
            folderPath: ValueAdapter.toResource(store, FtpServerLocation.FOLDER_PATH) || undefined
        };
        return resource;
    }

    public _toModel(resource: Model.FtpServerLocation, owner: Named): FtpServerLocation {
        const model = Owned.create<FtpServerLocation>(FtpServerLocation.MODEL, owner);
        ValueAdapter.toModel(model, FtpServerLocation.FILE_NAME, resource.fileName);
        ValueAdapter.toModel(model, FtpServerLocation.FOLDER_PATH, resource.folderPath);
        return model;
    }
}
